import { Table } from "antd";
import "./style.scss"
const UiTable = ({
    columns,
    rowKey,
    dataSource,
    rowSelection,
    components,
    ...restProp
}) => {
    return <div>
        <Table
            columns={columns}
            rowKey={rowKey}
            dataSource={dataSource}
            rowSelection={rowSelection}
            components={components}
            {...restProp}
            sticky={{x:true}}
        />
    </div>
};
export default UiTable